import drDevExpressReporting from './dr-devexpress-reporting.vue'

const schema = {
  allowInToolbox: true,
  $Type: 'dr-devexpress-reporting',
  name: 'DevExpress-Reporting',
  group: 'Advanced',
  icon: 'file-contract',
  properties: {
    $ID: {
      name: 'vuetifyWidgets.dr-base.id',
      type: 'string'
    },
    Class: {
      name: 'vuetifyWidgets.dr-base.cssClass',
      type: 'string'
    },
    ReportId: {
      name: 'Report Id',
      type: 'any',
      component: 'dr-devexpress-reporitng-designer'
    },
    Width: {
      name: 'Width',
      type: 'string'
    },
    Height: {
      name: 'Height',
      type: 'string'
    },
    ReportParameters: {
      name: 'Report parameters',
      type: 'any',
      component: 'dr-object-editor'
    }
  }
}

export default {
  schema,
  component: drDevExpressReporting,
  propEditors: [
    {
      name: 'dr-devexpress-reporitng-designer'
    }
  ]
}
